import { Button as MuiButton, Grid, Typography } from "@material-ui/core";

import React, { useEffect, useState } from "react";

import GovGrDrawerMenu from "../../components/GovGrDrawerMenu";
import { fetchApplicationKinds } from "../../services/applicationKindsService";
import { useQuery } from "react-query";
import {
  applicationBlue,
  applicationGreen,
  applicationPurple,
} from "../../theme/customColors";
import HomepageApplicationCard from "../external user/externalUserDashBoard/HomepageApplicationCard";
import { useSelector } from "react-redux";

function LandingPage() {
  const [applicationKindsWithColor, setApplicationKindsWithColor] = useState(
    []
  );
  const {
    data: applicationKinds,
    isLoading,
    isError,
    refetch,
  } = useQuery("applicationKinds", fetchApplicationKinds);

  useEffect(() => {
    if (applicationKinds?.length > 0) {
      setApplicationKindsWithColor(
        applicationKinds.map((applicationKind, index) => ({
          ...applicationKind,
          themeColor:
            index === 0
              ? applicationBlue
              : index === 1
              ? applicationGreen
              : index === 2
              ? applicationPurple
              : applicationBlue,
        }))
      );
    }
  }, [applicationKinds]);
  return (
    <GovGrDrawerMenu apptitle="E-θυρίδα Ναυτικού" hiddenmenu={true}>
      <Grid
        justifyContent="space-evenly"
        alignContent="flex-start"
        container
        spacing={6}
      >
        {applicationKindsWithColor?.map((applicationKind) => (
          <HomepageApplicationCard
            key={applicationKind?.id}
            themeColor={applicationKind.themeColor}
            title={applicationKind?.dscr}
            details={applicationKind?.details}
            applicationKindId={applicationKind?.id}
          />
        ))}
      </Grid>
    </GovGrDrawerMenu>
  );
}

export default LandingPage;
